<template>


                <div class="trendsBoxContainer">
                    <div class="imageBox">
                        <div class="imgWrap">
                            <svg width="32" height="32" viewBox="0 0 32 32">
                                <g fill="none" fill-rule="evenodd">
                                    <g>
                                        <g>
                                            <g
                                                transform="translate(-1176 -793) translate(1176 793) translate(7 3)"
                                            >
                                                <path
                                                    fill="#45658B"
                                                    d="M2.25 12.067L8.25 12.067 8.25 26.067 5.25 22.249 2.25 26.067z"
                                                    transform="rotate(15 5.25 19.067)"
                                                ></path>
                                                <path
                                                    fill="#45658B"
                                                    d="M9.982 12.067L15.982 12.067 15.982 26.067 12.982 22.249 9.982 26.067z"
                                                    transform="scale(-1 1) rotate(15 0 -79.541)"
                                                ></path>
                                                <circle
                                                    cx="9"
                                                    cy="8"
                                                    r="8"
                                                    fill="#FFD843"
                                                    stroke="#FF806B"
                                                    stroke-width="2"
                                                ></circle>
                                                <path
                                                    fill="#FF806B"
                                                    d="M9 10.5L6.061 12.045 6.622 8.773 4.245 6.455 7.531 5.977 9 3 10.469 5.977 13.755 6.455 11.378 8.773 11.939 12.045z"
                                                ></path>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </svg>
                        </div>
                        <div class="content">
                            <h3 v-if="$store.state.luxury != null" class="subTitle">
                                10 / {{ $store.state.luxury }}
                            </h3>
                            <h3 v-else class="subTitle">נתון לא ידוע</h3>
                            <p class="text">ציון יוקר של ה{{ summaryTypeName }}</p>
                        </div>
                    </div>
                    <div class="imageBox">
                        <div class="imgWrap">
                            <svg width="32" height="32" viewBox="0 0 32 32">
                                <g fill="none" fill-rule="evenodd">
                                    <g>
                                        <g>
                                            <g
                                                transform="translate(-1494 -1008) translate(1494 1008) translate(3 3)"
                                            >
                                                <rect
                                                    width="2"
                                                    height="26"
                                                    fill="#57CC9D"
                                                    rx="1"
                                                ></rect>
                                                <rect
                                                    width="5"
                                                    height="11"
                                                    x="4"
                                                    y="15"
                                                    fill="#FFD843"
                                                    rx="2"
                                                ></rect>
                                                <rect
                                                    width="5"
                                                    height="14"
                                                    x="18"
                                                    y="12"
                                                    fill="#FFD843"
                                                    rx="2"
                                                ></rect>
                                                <rect
                                                    width="5"
                                                    height="25"
                                                    x="11"
                                                    y="1"
                                                    fill="#FFD843"
                                                    rx="2"
                                                ></rect>
                                                <path
                                                    stroke="#45658B"
                                                    stroke-dasharray="2 2"
                                                    stroke-linecap="round"
                                                    stroke-width="3"
                                                    d="M4 11c1.333-3.333 3.333-5 6-5 4 0 4 2 8 2 2.667 0 4.667-2 6-6"
                                                ></path>
                                                <rect
                                                    width="26"
                                                    height="2"
                                                    y="24"
                                                    fill="#57CC9D"
                                                    rx="1"
                                                ></rect>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </svg>
                        </div>
                        <div class="content">
                            <h3
                                v-if="
                                    $store.state.priceIncreases != null &&
                                    $store.state.priceIncreases != 0
                                "
                                class="subTitle"
                            >
                                {{ $parent.upOrDown }}
                                <span class="price-value">{{ $store.state.priceIncreases }}%</span>
                            </h3>
                            <h3 v-else class="subTitle">עליית מחירים - לא ידוע</h3>
                            <p class="text" style="direction: rtl;"
                                v-if="
                                    $store.state.priceIncreases != null &&
                                    $store.state.priceIncreases != 0
                                "
                            >
                            {{ $parent.upOrDown }} 
                                 בשנה האחרונה

                                <!-- <span>{{ $store.state.priceIncreases }}%</span> -->
                            </p>
                        </div>
                    </div>
                    <div class="imageBox">
                        <div class="imgWrap">
                            <svg width="28" height="28" viewBox="0 0 28 28">
                                <g fill="none" fill-rule="evenodd">
                                    <g>
                                        <g>
                                            <g
                                                transform="translate(-415 -514) translate(413 512) translate(2 2)"
                                            >
                                                <path
                                                    fill="#45658B"
                                                    d="M16 16H25V19H16zM3 9H12V12H3zM8 0L16 9 0 9z"
                                                ></path>
                                                <path
                                                    fill="#45658B"
                                                    d="M20 19L28 28 12 28z"
                                                    transform="matrix(1 0 0 -1 0 47)"
                                                ></path>
                                                <circle
                                                    cx="14"
                                                    cy="14"
                                                    r="8"
                                                    fill="#FFD843"
                                                ></circle>
                                                <path
                                                    fill="#FF806B"
                                                    fill-rule="nonzero"
                                                    d="M14.427 19c.103 0 .185-.024.246-.072.06-.048.09-.113.09-.195v-.777c.99-.082 1.778-.323 2.361-.723.584-.4.876-.922.876-1.566 0-.437-.117-.797-.35-1.078-.234-.282-.596-.515-1.086-.7-.49-.185-1.151-.352-1.983-.5-.597-.119-1.057-.23-1.38-.333-.322-.104-.555-.223-.7-.356-.145-.133-.217-.3-.217-.5 0-.296.147-.522.441-.678.294-.155.698-.233 1.212-.233.467 0 .857.08 1.17.239.313.159.497.357.553.594.075.134.21.2.407.2h1.33c.085 0 .155-.022.21-.066.057-.045.085-.1.085-.167-.019-.274-.143-.556-.372-.845-.228-.288-.56-.542-.994-.76-.435-.22-.955-.362-1.562-.428v-.79c0-.08-.03-.146-.091-.194-.061-.048-.143-.072-.246-.072h-.868c-.094 0-.173.024-.239.072-.065.048-.098.113-.098.195v.766c-.915.09-1.636.334-2.164.734-.528.4-.792.889-.792 1.466 0 .637.257 1.126.77 1.467.514.34 1.322.615 2.425.822.663.141 1.165.261 1.506.361.34.1.595.217.763.35.168.134.252.3.252.5 0 .304-.165.543-.497.717-.331.174-.82.261-1.464.261-.58 0-1.034-.085-1.366-.255-.332-.17-.549-.382-.651-.634-.057-.074-.115-.128-.176-.16-.06-.034-.147-.05-.259-.05h-1.26c-.085 0-.157.023-.218.071-.06.048-.091.102-.091.161.019.341.152.662.4.962.247.3.611.553 1.092.76.481.208 1.058.338 1.73.39v.777c0 .082.033.147.098.195.066.048.145.072.239.072h.868z"
                                                ></path>
                                                <path
                                                    fill="#FF806B"
                                                    d="M13 9H15V11H13zM13 17H15V19H13z"
                                                ></path>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </svg>
                        </div>
                        <div class="content">
                            <h3 v-if="$store.state.Yield != null" class="subTitle">
                                {{ $store.state.Yield }}% תשואה
                            </h3>
                            <h3 v-else class="subTitle">תשואה - לא ידוע</h3>
                            <p class="text">תשואת שכירות חציונית שנתית</p>
                        </div>
                    </div>
                </div>
</template>
<script>


export default {
    name: "TrendCards",
    components: {

    },
    data() {
        return {
        };
    },
    computed: {
        // computed properties
        summaryTypeName() {
			if (("summaryTypeName", this.$store.state.neighborhoodId > 0)) {
				return "שכונה";
			}
			return "ישוב";
		},
        upOrDown() {
			if (this.getPriceDifferencePercentage < 0) {
				return "ירידת מחירים";
			} else {
				return "עליית מחירים";
			}
		},
        getPriceDifferencePercentage() {
			if (this.$patent.selectedTab == "all") {
				return this.$store.state.priceDifferencePercentage;
			} else if (this.$patent.selectedTab == "3") {
				return this.$store.state.priceDifferencePercentage_3;
			} else if (this.$patent.selectedTab == "4") {
				return this.$store.state.priceDifferencePercentage_4;
			} else if (this.$patent.selectedTab == "5") {
				return this.$store.state.priceDifferencePercentage_5;
			} else {
				return null;
			}
		},
        upOrDown_s(){
			if (this.$store.state.priceIncreases > 0) {
				return "עלו";
			}
			else if (this.$store.state.priceIncreases < 0) {
				return "ירדו";
			}
			else {
				return null;
			}
		},

    },
};

</script>



<style scoped>



.price-value {
    unicode-bidi: bidi-override;
    direction: ltr;
}

</style>